const OrderTbcList = () => import('@/modules/fwscvendor/atbc/OrderTbcList')
const PendingContractList = () => import('@/modules/fwscvendor/bpendingcontract/PendingContractList')
const ConfirmContractList = () => import('@/modules/fwscvendor/cconfirmcontract/ConfirmContractList')
const OrderToPayList = () => import('@/modules/fwscvendor/dtopay/OrderToPayList')
const OrderToService = () => import('@/modules/fwscvendor/etoservice/OrderToService')

const SellerSureFinishSer = () => import('@/modules/fwscvendor/fsellersure/SellerSureFinishSer')
const BuyerSureFinishSer = () => import('@/modules/fwscvendor/gbuyersure/BuyerSureFinishSer')

const OrderToComment = () => import('@/modules/fwscvendor/htocommect/OrderToComment')
const OrderFinshList = () => import('@/modules/fwscvendor/ifinish/OrderFinshList')
const OrderRefuse = () => import('@/modules/fwscvendor/jorderrufuse/OrderRefuse')
export default [
  {

    path: '/ordertbc',
    name: 'ordertbc',
    component: OrderTbcList,
    meta: {
      title: '订单--待接单',
      isBlack: true
    },
  },
  {

    path: '/orderpendingcontract',
    name: 'pendingcontract',
    component: PendingContractList,
    meta: {
      title: '订单--待拟合同',
      isBlack: true
    },
  },
  {

    path: '/confirmcontract',
    name: 'confirmcontract',
    component: ConfirmContractList,
    meta: {
      title: '订单--合同待确认',
      isBlack: true
    },
  },
  {

    path: '/ordertopay',
    name: 'ordertopay',
    component: OrderToPayList,
    meta: {
      title: '订单--待支付',
      isBlack: true
    },
  },
  {

    path: '/ordertoservice',
    name: 'ordertoservice',
    component: OrderToService,
    meta: {
      title: '订单--待服务',
      isBlack: true
    },
  },
  {
    path: '/sellsurefinish',
    name: 'sellsurefin',
    component: SellerSureFinishSer,
    meta: {
      title: '卖方确认服务完成',
      isBlack: true
    },
  },
  {

    path: '/buysurefinish',
    name: 'buysurefin',
    component: BuyerSureFinishSer,
    meta: {
      title: '买方确认服务完成',
      isBlack: true
    },
  },

  {

    path: '/ordertocomment',
    name: 'ordertocomment',
    component: OrderToComment,
    meta: {
      title: '订单--待评价',
      isBlack: true
    },
  },
  {

    path: '/orderfinish',
    name: 'orderfinsh',
    component: OrderFinshList,
    meta: {
      title: '订单--已完成',
      isBlack: true
    },
  },
  {
    path: '/orderrefuse',
    name: 'orderrefuse',
    component: OrderRefuse,
    meta: {
      title: '订单--已拒单',
      isBlack: true
    },
  },

]
